import { css, cva } from '@/styled-system/css';

export const titleRowStyles = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const boxContainerStyles = cva({
  base: {
    padding: 'default',
    borderRadius: '{radii.obj.sharp}',
    border: '1px solid',
    borderColor: 'border.muted',
  },
  variants: {
    isEditMode: {
      true: {
        padding: 'zero',
        borderWidth: '0px',
        borderColor: 'transparent',
      },
    },
  },
});
